import Slider from "react-slick";
import "./MobileList.css";
import styles from "../Styles.module.css";

import Spinner from "../../../general/spinner/Spinner";
import LoadMoreArrow from "../../../../img/load-more-arrow.svg";
import { BroadcastObject } from "types/broadcast";
import { addSeconds } from "date-fns";
import { format } from "date-fns";
interface Props {
	data: BroadcastObject[];
	showMoreData: () => void;
	isGettingMore: boolean;
	moreToShow: boolean;
	selectBroadcast: (id: string) => void;
}
const MobileList = ({ data, showMoreData, isGettingMore, moreToShow, selectBroadcast }: Props) => {
	var settings = {
		dots: false,
		infinite: false,
		speed: 200,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		centerMode: true,
		draggable: true,
	};

	const getEndTime = (date: string, increase: string) => {
		var startdate = new Date(date);
		var returned_endate = addSeconds(startdate, Number(increase));
		return returned_endate;
	};

	return (
		<div className="mobileMediaList">
			<Slider {...settings}>
				{data.length !== 0
					? data.map((item) => {
							let endTime = getEndTime(item.date, item.expected_duration);
							return (
								<button key={item.id} onClick={() => selectBroadcast(item.id)} className="itemLink">
									<div
										className={styles.contentBlockImg}
										style={{ backgroundImage: `url(${item.medium_image})` }}
									></div>
									<div className="mt-2 align-start">
										<h6 className="text-body fs-5">{item.title}</h6>

										<p className="text-body">
											TIME:{" "}
											<span className="text-muted">
												{format(new Date(item.date), "hh:mm a")} - {format(endTime, "hh:mm a")}
											</span>
										</p>

										<p className="text-muted">{format(new Date(item.date), "MMM dd yyyy")}</p>
									</div>
								</button>
							);
					  })
					: null}
				{moreToShow ? (
					<div className="loadMoreBtnWrapper">
						{isGettingMore ? (
							<Spinner color="255, 255, 255" />
						) : (
							<button className="loadMoreBtn" onClick={() => showMoreData()}>
								LOAD MORE
								<img src={LoadMoreArrow} alt="Load More" />
							</button>
						)}
					</div>
				) : null}
			</Slider>
		</div>
	);
};
export default MobileList;
